import { Helmet } from "react-helmet";
import UnderConstruction from "./UnderConstruction";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Helmet>
        <title>Lara und die Wand im Kopf</title>
        <meta
          name="description"
          content="Ein inspirierendes Kinderbuch über Mut, Freundschaft und das Klettern. Begleite Lara auf ihrer Reise an der Kletterwand – und darüber hinaus."
        />
        <script type="application/ld+json">
          {`
      {
        "@context": "http://schema.org",
        "@type": "Book",
        "name": "Lara und die Wand im Kopf",
        "author": {
          "@type": "Person",
          "name": "Stephan Hölscher",
          "email": "stephan@wandtagebuch.de"
        },
        "description": "Ein inspirierendes Kinderbuch über Mut, Freundschaft und das Klettern. Begleite Lara auf ihrer Reise an der Kletterwand – und darüber hinaus.",
        "genre": "Kinderbuch, Abenteuer, Coming-of-Age",
        "inLanguage": "de",
        "publisher": "Selbstverlag über Amazon KDP",
        "url": "https://www.wandtagebuch.de/"
      }
    `}
        </script>
      </Helmet>
      <UnderConstruction language="de" />
    </div>
  );
}

export default App;
